import * as types from '@/store/types'
import axios from 'axios'
import constConf from '../../../constconf.js'

export default {
    saveKeyboard: async (context, payload) => {
        payload = Object.assign({}, payload)
        let method = 'post'
        let url = constConf.message.url + '/keyboard/create'
        if (payload.id != null) {
            method = 'put'
            url = constConf.message.url + '/keyboard/update/' + payload.id
        }
        payload.struct = JSON.stringify(payload.struct) // преобразование в строку
        axios.defaults.withCredentials = true
        return axios({
            method: method,
            url: url,
            data: payload
        })
            .then((response) => {
                let functionName = { put: 'setKeyboard', post: 'addKeyboard' }
                context.commit(functionName[method], response.data)
                return response.data
            })
            .catch((error) => {
                console.log('ошибка при записи значения')
                console.log(error)
            })
    },
    loadKeyboards: async (context, botId) => {
        let keyboardsDef = [
            {
                id: null,
                title: 'Без клавиатуры',
                struct: '[[]]',
                visible_in_list: 1
            },
            {
                id: null,
                title: 'Новая клавиатура',
                struct: '[[]]',
                visible_in_list: 1
            }
        ]
        axios.defaults.withCredentials = true
        axios.get(constConf.message.url + '/keyboard/all/' + botId).then(response => {
            if (response.data.keyboards.length !== 0) {
                context.commit('loadKeyboards', keyboardsDef.concat(response.data.keyboards))
            } else {
                context.commit('loadKeyboards', keyboardsDef)
            }
            // eslint-disable-next-line handle-callback-err
        }).catch((error) => {
            console.log('error get keyboards' + error)
        })
    },
    removeKeyboard: (context, index) => {
        axios.defaults.withCredentials = true
        return axios({
            method: 'delete',
            url: constConf.message.url + '/keyboard/delete/' + context.getters.keyboards[index].id
        })
            .then((response) => {
                context.commit('removeKeyboard', index)
                return response.data
            })
            .catch((error) => {
                console.log('ошибка при записи значения')
                console.log(error)
            })
    }
}
